<template>
  <div>
    <div class="page-header clear-filter" filter-color="black2">
      <parallax class="page-header-image" style="background-image:url('/img/img_main_land.png')"></parallax>
      <div class="container" id="top">
        <div class="row" style="margin-top: 30%;">
          <div data-aos="fade-right" class="col-lg-5" style="margin: auto;">
            <h1 
              class="h1"
              style="
              text-align: right; 
              font-size: 6em;
              font-weight: 900;
              font-stretch: normal;
              font-style: normal;
              line-height: normal;
              letter-spacing: -4.93px;
              text-transform: uppercase;
              margin-right: 20px;
              margin-left: 20px;
              color: #ffffff;"
            >{{$t('menu_land')}}</h1>
          </div>
          <div class="col-lg-1">
          </div>
          <div data-aos="fade-left" class="col-lg-6" style="margin: auto;">
            <h5 class="description" style="
            font-size: 1.2em;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: -0.98px;
            text-align: left;
            color: #ffffff;
            ">{{$t(`land detail desc`)}}</h5>
          </div>
        </div>
      </div>
    </div>
    <landfeatures-section></landfeatures-section>
    <landdata-section></landdata-section>
  </div>
</template>
<script>
import { Parallax } from "@/components";
import LandfeaturesSection from "./components/LandfeaturesSection";
import LandpresaleSection from "./components/LandpresaleSection";
import LanddataSection from "./components/LanddataSection";

export default {
  name: "land",
  bodyClass: "land-page",
  components: {
    Parallax,
    LandfeaturesSection,
    LandpresaleSection,
    LanddataSection
  }
};
</script>
<style></style>
